export default "__VITE_ASSET__Bx50OMs4__"